import { Spinner } from "react-bootstrap";
export const SectionLoader = ({ className }) => (
  <div className="section-loader">
    <Spinner animation="grow" size="sm" className="mr-1" variant="success" />
    <Spinner animation="grow" size="sm" className="mr-1" variant="danger" />
    <Spinner animation="grow" size="sm" className="mr-1" variant="warning" />
    <Spinner animation="grow" size="sm" className="mr-1" variant="info" />
  </div>
);
